import { useRef } from 'react';

export const useModalDnd = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const getContainerForClone = () =>
    containerRef.current?.closest('dialog') ?? document.body;

  return { containerRef, getContainerForClone };
};
